import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Link as MuiLink, Grid, makeStyles, Theme, Button, Backdrop } from "@material-ui/core";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import { columns } from "./components/columns";
import { searchData } from "src/app-redux/common-actions";
import {
  setSelectedVehicleId,
  setSelectedVehicleScanId,
  loader as vehicleLoader,
} from "src/app-redux/vehicle/vehicleSlice";
import Drawer from "./components/Drawer";
import DrawerVehicleDetails from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import { filteryByArr } from "src/common/utils/app.dropdowns";
import { filterBy } from "src/common/utils/helpers";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { Check, Close } from "@material-ui/icons";
import { Tooltip } from "@mui/material";
import { getVehicleDetailsByIdAction } from "src/app-redux/vehicle/actions/vehicleActions";
import { useAppSelector } from "src/app-redux/hooks";
import CommonLoader from "src/components/Loader/CommonLoader";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    display: "flex",
    minHeight: 500,
    "& .MuiDataGrid-columnHeaderWrapper": {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .MuiDataGrid-columnHeaderWrapper .MuiIconButton-label svg": { color: "rgba(255,255,255,1)" },
  },
  cardMain: {
    marginBottom: "0px",
    paddingTop: "2px",
    width: "calc(100%)",
  },
  pageHeading: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#000",
  },
  breadcrumbs: {
    fontSize: theme.typography.pxToRem(12),
  },
  button: {
    margin: theme.spacing(1),
  },
  hideDatesGrid: {
    display: "none",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    color: "#fff",
  },
  legend: { fontWeight: "bold", color: "black", fontSize: "12px" },
  multiselectConfigFileCompression: {
    position: "relative",
    paddingLeft: "4px",
    "& .searchWrapper": {
      border: "none",
      maxHeight: "35px",
      overflow: "auto",
    },
    "& ::placeholder": {
      color: "#bcbcbc",
    },
  },
}));

interface Props {}

export function InspectionScanner({}: Props): React.ReactElement {
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [vehicleRecord, setvehicleRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const loader2: any = useAppSelector(vehicleLoader);

  const [isCustomDate, setIsCustomDate] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [isVehicleDrawerOpen, setisVehicleDrawerOpen] = React.useState(false);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);

  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const handleCloseVehicleDrawer = () => {
    setisVehicleDrawerOpen(false);
  };
  const startDatePickerRef: any = useRef(null);
  const endDatePickerRef: any = useRef(null);

  const formik = useFormik({
    initialValues: {
      filterBy: "today",
      startDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      endDate: moment(new Date(new Date().setDate(new Date().getDate())).setHours(23, 59)).format(
        "YYYY-MM-DDTHH:mm"
      ),
      deletedScanDataOnly: true,
    },
    onSubmit: () => {
      // alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  const compareByDeletedDate = (a: any, b: any) => {
    const dateA = new Date(a.deletedAt);
    const dateB = new Date(b.deletedAt);

    if (dateA < dateB) {
      return 1;
    } else if (dateA > dateB) {
      return -1;
    } else {
      const timeA = new Date(a.deletedAt).getTime();
      const timeB = new Date(b.deletedAt).getTime();
      if (timeA < timeB) {
        return 1;
      } else if (timeA > timeB) {
        return -1;
      } else {
        return 0;
      }
    }
  };

  const handleSearch = async () => {
    const { filterBy, startDate, endDate, deletedScanDataOnly } = values;
    const body = {
      filterBy: filterBy || null,
      startDate: startDate || null,
      endDate: endDate || null,
      deletedScanDataOnly: deletedScanDataOnly || true,
    };
    setvehicleRecord([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-all-deleted-scan", JSON.stringify(body))
      );
      const record = results.vehicleInspectionScans;
      if (record) {
        record.sort(compareByDeletedDate);
        const transformedData = record.map((data: any, index: any) => {
          return { ...data, vehicleScanId: data.id, id: index };
        });
        setvehicleRecord(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };

  const [resetHandler, setResetHandler] = useState(false);

  const resetGrid = () => {
    setValues({
      ...formik.values,
      filterBy: formik.initialValues.filterBy,
      startDate: formik.initialValues.startDate,
      endDate: formik.initialValues.endDate,
    });
    setIsCustomDate(false);
    setResetHandler(true);
  };

  useEffect(() => {
    formik.setFieldValue("filterBy", "today");
    setLoader(true);
    handleSearch();
    setResetHandler(false);
  }, [resetHandler]);

  const filterByAction = (data: any) => {
    formik.setFieldValue("filterBy", data.value);
    if (data && data.value) {
      const res = filterBy(data);
      if (res?.isCustomDate) {
        setIsCustomDate(true);
        formik.setFieldValue("startDateCustom", res?.startDate);
        formik.setFieldValue("endDateCustom", res?.endDate);
      } else {
        setIsCustomDate(false);
      }
      formik.setFieldValue("startDate", res?.startDate);
      formik.setFieldValue("endDate", res?.endDate);
    }
  };

  useEffect(() => {
    if (vehicleRecord.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "remarks"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return (
                  <Tooltip title={renderedCellValue} followCursor>
                    <span>{renderedCellValue}</span>
                  </Tooltip>
                );
              },
            }
          : column.accessorKey === "serialNumber"
          ? {
              ...column,
              Cell: function customCell({ renderedCellValue }: any) {
                return <div>{renderedCellValue ? renderedCellValue : "--"}</div>;
              },
            }
          : column.accessorKey === "registrationNumber"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(getVehicleDetailsByIdAction(row.original.gatePassId));
                      dispatch(setSelectedVehicleId(row.original.gatePassId));
                      setisVehicleDrawerOpen(true);
                    }}
                  >
                    {row.original.registrationNumber}
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "files"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <MuiLink
                    className="customMuiLink"
                    onClick={() => {
                      dispatch(
                        setSelectedVehicleScanId({
                          scanId: row.original.vehicleScanId,
                          regNo: row.original.registrationNumber,
                          isNodWeightFile: true,
                        })
                      );
                      setisDrawerOpen(true);
                    }}
                  >
                    View
                  </MuiLink>
                );
              },
            }
          : column.accessorKey === "vehicleInProgress"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                return (
                  <React.Fragment>
                    <Box>
                      <Tooltip title={row.original?.vehicleInProgress ? "Yes" : "No"}>
                        <Button style={{ minWidth: "30px", padding: "4px", color: "gray" }}>
                          {row.original?.vehicleInProgress ? <Check /> : <Close />}
                        </Button>
                      </Tooltip>
                    </Box>
                  </React.Fragment>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, [vehicleRecord]);

  return (
    <div>
      <Backdrop className={classes.backdrop} open={loader2}>
        <CommonLoader />
      </Backdrop>
      <Drawer
        isDrawerOpen={isDrawerOpen}
        handleCloseDrawer={() => {
          handleCloseDrawer();
        }}
      />
      {!loader2 && (
        <DrawerVehicleDetails
          isDrawerOpen={isVehicleDrawerOpen}
          handleCloseDrawer={() => {
            handleCloseVehicleDrawer();
          }}
        />
      )}

      <Grid spacing={2} container direction="row">
        <Grid item xs={12} md={3} lg={3}>
          <CommonAutoCompleteField
            cssClassName="customTextField"
            error={formik.touched.filterBy && Boolean(formik.errors.filterBy)}
            helperText={formik.touched.filterBy && formik.errors.filterBy}
            label="Filter by"
            placeholder="Filter by"
            disableClearable={true}
            name="filterBy"
            optionsType={filteryByArr}
            getOptionLabel={(option: any) => option.label || null}
            onChange={(row: any) => {
              row ? setValues({ ...values, filterBy: row.value || "" }) : "";
              if (row === null) {
                formik.setFieldValue("filterBy", null);
              }
              filterByAction(row);
            }}
            value={filteryByArr.find(({ value }: any) => value === formik.values.filterBy) || ""}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"Start Date"}
            name={"startDate"}
            datePickerRef={startDatePickerRef}
            value={formik.values.startDate}
            onChange={(e: any) => {
              formik.setFieldValue("startDate", moment(e).format("YYYY-MM-DDTHH:mm"));
              formik.setFieldValue("endDate", "");
            }}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>
        <Grid item xs={12} md={3} lg={3} className={!isCustomDate ? classes.hideDatesGrid : ""}>
          <CommonTextFieldDate
            cssClassName="customTextField"
            label={"End Date"}
            name={"endDate"}
            datePickerRef={endDatePickerRef}
            value={formik.values.endDate}
            onChange={(e: any) => {
              formik.setFieldValue("endDate", moment(e).format("YYYY-MM-DDTHH:mm"));
            }}
            minDate={formik.values.startDate}
            maxDate={moment().format("YYYY-MM-DDTHH:mm")}
          />
        </Grid>

        <Grid item xs={12} md={isCustomDate ? 12 : 3} lg={isCustomDate ? 3 : 9}>
          <Box textAlign="right" mt={1} mb={1} style={{ float: "right" }}>
            <CommonButton cssClass="customSubmitBtn" onClick={() => resetGrid()}>
              Reset
            </CommonButton>
            <CommonButton cssClass="customSubmitBtn" isGreen onClick={handleSearch}>
              Search
            </CommonButton>
          </Box>
        </Grid>
      </Grid>
      <CommonMaterialGrid
        rows={vehicleRecord}
        columns={displayColumns}
        defaultPerPageRecord={15}
        height={550}
        loader={loader}
      />
    </div>
  );
}
